module.exports = __webpack_public_path__ + "static/map-uae-164e06c0c3d80ff088153d7620bc0fde.png";